export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-submenu-1.0.0',
    name: 'JDSDropdownMenuSubMenu'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_dropdown_menu_sub_menu_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 65,
      'background-color': '{global.transparent}',
      passive: true
    }
  },
  variant: {
    _platform: {
      mobile: {
        'popup-container': {
          size: '{size.max}'
        }
      }
    }
  },
  api: {
    data: {
      'popup-container': {
        'padding-left': {
          type: 'size',
          name: 'offsetX'
        },
        'padding-top': {
          type: 'size',
          name: 'offsetY'
        }
      },
      jds_dropdown_menu_sub_menu_internal: {
        _menuWidth: {
          type: 'size',
          name: '_menuWidth'
        },
        _menuMaxHeight: {
          type: 'size',
          name: '_menuMaxHeight'
        },
        triggerRef: {
          type: 'ref',
          name: 'triggerRef'
        },
        children: {
          name: 'children',
          type: 'slot',
          accepts: ['jds_dropdown_menu_group']
        }
      }
    },
    events: {
      jds_dropdown_menu_sub_menu_internal: {
        onAppear: {
          name: '_onAppear',
          platform: 'ios'
        },
        onSelect: 'onSelect'
      }
    },
    config: {
      _platform: {
        values: ['mobile', 'desktop']
      },
      _menuContainerVisible: {
        values: [false, true]
      }
    }
  }
};
